import { useGetProfessionalReferralServicesQuery } from '../../generated/home';

const useProfessionalReferralServices = () => {
  const [{ data, fetching, error }] = useGetProfessionalReferralServicesQuery();

  return { services: data?.getProfessionalReferralServices ?? [], fetching, error };
};

export { useProfessionalReferralServices };
